<!--
  ~ This code is protected by intellectual property rights.
  ~ Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
  ~ © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
  -->

<p-banner [open]="isOpen" [state]="state" [dismissButton]="true" (dismiss)="dismissed.emit()">
  @if (heading) {
    <span slot="heading">{{ heading | translate }}</span>
  }
  <span>{{ message | translate }}</span>
</p-banner>
